import { REGISTRATION_STATES } from '@/Text/config/registrationStatus';

export const ADDRESS_PO_BOX_MESSAGE = `PO Box address is not accepted, a physical
 street address is required for your brand
 to be approved.`;

export const COUNTRIES = [
  { value: 'US', text: 'United States' },
  { value: 'CA', text: 'Canada' },
];

export const BUSINESS_TYPE = [
  { text: 'Partnership' },
  { text: 'Corporation' },
  { text: 'Co-operative' },
  { text: 'Limited Liability Corporation' },
  { text: 'Non-profit Corporation' },
];
export const EIN = 'EIN';
export const DUNS = 'DUNS';
export const BIN = 'BIN';

export const BUSINESS_REGISTRATION_ID_TYPE = [
  { value: EIN, text: 'USA: Employer Identification Number (EIN)' },
  { value: BIN, text: 'Canada: Business Number (BN)' },
];

export const BUSINESS_INDUSTRY = [
  { text: 'Real Estate', value: 'REAL_ESTATE' },
  { text: 'Insurance', value: 'INSURANCE' },
  { text: 'Automotive', value: 'AUTOMOTIVE' },
  { text: 'Agriculture', value: 'AGRICULTURE' },
  { text: 'Banking', value: 'BANKING' },
  { text: 'Construction', value: 'CONSTRUCTION' },
  { text: 'Consumer', value: 'CONSUMER' },
  { text: 'Education', value: 'EDUCATION' },
  { text: 'Engineering', value: 'ENGINEERING' },
  { text: 'Energy', value: 'ENERGY' },
  { text: 'Oil and Gas', value: 'OIL_AND_GAS' },
  { text: 'Fast Moving Consumer Goods', value: 'FAST_MOVING_CONSUMER_GOODS' },
  { text: 'Financial', value: 'FINANCIAL' },
  { text: 'Fintech', value: 'FINTECH' },
  { text: 'Food and Beverage', value: 'FOOD_AND_BEVERAGE' },
  { text: 'Government', value: 'GOVERNMENT' },
  { text: 'Healthcare', value: 'HEALTHCARE' },
  { text: 'Hospitality', value: 'HOSPITALITY' },
  { text: 'Legal', value: 'LEGAL' },
  { text: 'Manufacturing', value: 'MANUFACTURING' },
  { text: 'Media', value: 'MEDIA' },
  { text: 'Online', value: 'ONLINE' },
  { text: 'Professional Services', value: 'PROFESSIONAL_SERVICES' },
  { text: 'Raw Materials', value: 'RAW_MATERIALS' },
  { text: 'Religion', value: 'RELIGION' },
  { text: 'Retail', value: 'RETAIL' },
  { text: 'Jewelry', value: 'JEWELRY' },
  { text: 'Technology', value: 'TECHNOLOGY' },
  { text: 'Telecommunications', value: 'TELECOMMUNICATIONS' },
  { text: 'Transportation', value: 'TRANSPORTATION' },
  { text: 'Travel', value: 'TRAVEL' },
  { text: 'Electronics', value: 'ELECTRONICS' },
  { text: 'Not-for-profit', value: 'NOT_FOR_PROFIT' },
];

export const BUSINESS_REGIONS_OPERATIONS = [
  { text: 'Africa', value: 'AFRICA' },
  { text: 'Asia', value: 'ASIA' },
  { text: 'Europe', value: 'EUROPE' },
  { text: 'Latin America', value: 'LATIN_AMERICA' },
  { text: 'USA and Canada', value: 'USA_AND_CANADA' },
];

export const JOB_POSITIONS = [
  { text: 'Director', value: 'Director' },
  { text: 'GM', value: 'GM' },
  { text: 'VP', value: 'VP' },
  { text: 'CEO', value: 'CEO' },
  { text: 'CFO', value: 'CFO' },
  { text: 'General Counsel', value: 'General Counsel' },
  { text: 'Other', value: 'Other' },
];

export const COMPANY_TYPE = [
  { text: 'Private', value: 'private' },
  { text: 'Public', value: 'public' },
  { text: 'Non Profit', value: 'non-profit' },
];

export const TEAM_SIZE = [
  { text: '1-10' },
  { text: '3-5' },
  { text: '6-10' },
  { text: '11-20' },
  { text: '20+' },
];

export const CAMPAIGN_PAYLOAD_LITE_CUSTOMER = {
  campaign_description: 'Send marketing messages about sales and offers',
  message_sample_1: 'Getting qualified to buy a home, or to see how much money you can save in a refinance costs $32 for a credit report, and THAT’S IT! Reach back with questions, or get qualified: http://bit.ly/homeloanportal. Chris Carter, Edge Home Finance (A Low Rate Leader)',
  message_sample_2: 'Also, I have a few more questions and definitely want to let you know about your options. When\'s a good time to talk for 10 minutes?',
  us_app_to_person_use_case: 'SOLE_PROPRIETOR',
  has_embedded_links: true,
  has_embedded_phone: true,
};

export const STOCK_EXCHANGE_TYPE = [
  {
    text: "AMEX : American Stock Exchange",
    value: "AMEX"
  },
  {
    text: "AMX : Armenia Securities Exchange",
    value: "AMX"
  },
  {
    text: "ASX : Australian Securities Exchange",
    value: "ASX"
  },
  {
    text: "B3: Brazil Stock Exchange",
    value: "B3"
  },
  {
    text: "BME : Bolsas y Mercados Españoles",
    value: "BME"
  },
  {
    text: "BSE : Bombay Stock Exchange",
    value: "BSE"
  },
  {
    text: "FRA : Frankfurt Stock Exchange",
    value: "FRA"
  },
  {
    text: "ICEX : Indian Commodity Exchange",
    Value: "ICEX"
  },
  {
    text: "JPX : Japan Exchange Group",
    value: "JPX"
  },
  {
    text: "JSE : Jamaica Stock Exchange",
    value: "JSE"
  },
  {
    text: "KRX : Korea Exchange",
    value: "KRX"
  },
  {
    text: "LON : London Stock Exchange",
    value: "LON"
  },
  {
    text: "NASDAQ",
    value: "NASDAQ"
  },
  {
    text: "NSE : National Stock Exchange of India Ltd",
    value: "NSE"
  },
  {
    text: "NYSE : New York Stock Exchange",
    value: "NYSE"
  },
  {
    text: "None",
    value: "None"
  },
  {
    text: "OMX : NASDAQ Stockholm",
    value: "OMX"
  },
  {
    text: "SEHK : Stock Exchange of Hong Kong",
    value: "SEHK"
  },
  {
    text: "SGX : Singapore Exchange Limited",
    value: "SGX"
  },
  {
    text: "SSE : Shanghai Stock Exchange",
    value: "SSE"
  },
  {
    text: "STO : Stockholm Stock Exchange",
    value: "STO"
  },
  {
    text: "SWX : Swiss Stock Exchange",
    value: "SWX"
  },
  {
    text: "SZSE : Shenzhen Stock Exchange",
    value: "SZSE"
  },
  {
    text: "TSX : Toronto Stock Exchange",
    value: "TSX"
  },
  {
    text: "TWSE : Taiwan Stock Exchange",
    value: "TWSE"
  },
  {
    text: "VSE : Vadodara Stock Exchange Limited",
    value: "VSE"
  },
  {
    text: "Other",
    value: "Other"
  },
];

export const STEPS_SOLE_PROPRIETOR = {
  DECISION: 'DECISION',
  SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
  CAMPAIGN: 'CAMPAIGN',
  PAYMENT: 'PAYMENT',
  STATUS: 'STATUS',
};


export const INDUSTRIES = [
  { value: 'AGRICULTURE', text: 'AGRICULTURE' },
  { value: 'COMMUNICATION', text: 'COMMUNICATION' },
  { value: 'CONSTRUCTION', text: 'CONSTRUCTION' },
  { value: 'EDUCATION', text: 'EDUCATION' },
  { value: 'ENERGY', text: 'ENERGY' },
  { value: 'ENTERTAINMENT', text: 'ENTERTAINMENT' },
  { value: 'FINANCIAL', text: 'FINANCIAL' },
  { value: 'GOVERNMENT', text: 'GOVERNMENT' },
  { value: 'HEALTHCARE', text: 'HEALTHCARE' },
  { value: 'HOSPITALITY', text: 'HOSPITALITY' },
  { value: 'HEALTHCARE', text: 'HEALTHCARE' },
  { value: 'HUMAN_RESOURCES', text: 'HUMAN_RESOURCES' },
  { value: 'INSURANCE', text: 'INSURANCE' },
  { value: 'LEGAL', text: 'LEGAL' },
  { value: 'MANUFACTURING', text: 'MANUFACTURING' },
  { value: 'NGO', text: 'NGO' },
  { value: 'POLITICAL', text: 'POLITICAL' },
  { value: 'POSTAL', text: 'POSTAL' },
  { value: 'PROFESSIONAL', text: 'PROFESSIONAL' },
  { value: 'REAL_ESTATE', text: 'REAL_ESTATE' },
  { value: 'RETAIL', text: 'RETAIL' },
  { value: 'TECHNOLOGY', text: 'TECHNOLOGY' },
  { value: 'TRANSPORTATION', text: 'TRANSPORTATION' },
];

export const STANDARD_RETRY_STATES = [
  REGISTRATION_STATES.CAMPAIGN_TWILIO_FAILED,
  REGISTRATION_STATES.CAMPAIGN_TCR_FAILED,
  REGISTRATION_STATES.BRAND_FAILED,
  REGISTRATION_STATES.A2P_BUNDLE_FAILED,
  REGISTRATION_STATES.CUSTOMER_PROFILE_FAILED,
  REGISTRATION_STATES.BRAND_TCR_FAILED,
];